import React, { useEffect } from "react";
import { useLocalStore, useStoreState } from "easy-peasy";
import cn from "classnames";
import { snakeCase } from "lodash";
import { Typography, Paper, Box, Grid } from "@mui/material";
import { OutlinedBtn } from "components/admin_v2/ui/Buttons";
import BreadCrumbs from "components/admin_v2/common/BreadCrumbs";
import Spinner from "components/admin_v2/ui/Spinner";
import RouterLink from "components/admin_v2/nav/RouterLink";
import TopPageLayout from "components/admin_v2/nav/TopPageLayout";
import SchoolConfigTabs from "components/admin_v2/settings_config/SettingsConfigTabs";
import UserAssociations from "components/admin_v2/settings_config/users/UserAssociations";
import I18n from "utils/i18n.js";
import { usersStore } from "components/admin_v2/common/stores/usersStore";
import { pageRoutes } from "services/api";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const DETAIL_FIELDS = ["email", "firstName", "lastName", "createdAt", "updatedAt"];

const User = (props) => {
  const { user: currentUser, isRestrictedAdmin } = useStoreState((s) => s.app);
  const cls = useCommonPageStyles();
  const [state, actions] = useLocalStore(() => usersStore({ role: "admin" }));
  const id = props.match.params.id;
  const user = state.user;

  useEffect(() => {
    if (!id || id === "new") return;
    actions.fetchUser(id);

    return () => {
      actions.setUser(null);
    };
  }, [id]);

  if (isRestrictedAdmin && currentUser?.id != id) {
    return null;
  }

  const detail = (prop) => {
    return (
      <Box className={cn(`details-${prop}`, cls.detail)} key={prop}>
        <div className={cls.detailHeader}>
          {I18n.t(`settings_config.user.labels.${snakeCase(prop)}`)}
        </div>
        <div>{user[prop] || I18n.t("ui.empty_field")}</div>
      </Box>
    );
  };

  return (
    <React.Fragment>
      <TopPageLayout title={I18n.t("settings_config.title")} />
      <SchoolConfigTabs />
      <BreadCrumbs path={pageRoutes.users()} label={I18n.t("settings_config.users.breadcrumb")} />
      {user && (
        <Box className={cls.titleWithBtn}>
          <Typography variant="h1" gutterBottom>
            {user.name}
          </Typography>
          <Box className={cls.btnsWrapper}>
            <OutlinedBtn className={cls.actionBtn} onClick={() => actions.resetPassword(id)}>
              {I18n.t("ui.btn.reset_password")}
            </OutlinedBtn>
            <RouterLink className={cls.actionBtn} to={pageRoutes.userEdit(user.id)}>
              <OutlinedBtn>{I18n.t("settings_config.edit_user.btn")}</OutlinedBtn>
            </RouterLink>
            {!isRestrictedAdmin && (
              <OutlinedBtn className={cls.actionBtn} onClick={() => actions.toggleArchive(id)}>
                {user.discarded ? I18n.t("ui.btn.unarchive") : I18n.t("ui.btn.archive")}
              </OutlinedBtn>
            )}
          </Box>
        </Box>
      )}
      <Box my={5}>
        <Paper className={cls.paper}>
          {state.loading ? (
            <Spinner />
          ) : (
            <>
              <Box className={cls.subTitle}>{I18n.t("settings_config.user.title.details")}</Box>
              <Grid container className={cls.grid} spacing={5}>
                <Grid item xs={6}>
                  {user && DETAIL_FIELDS.map(detail)}
                </Grid>
              </Grid>
            </>
          )}
        </Paper>
      </Box>
      {user && <UserAssociations user={user} />}
    </React.Fragment>
  );
};

export default User;
